{
  "personal-data-form": {
    "text": {
      "birthday": "Anniversaire",
      "name": "Nom",
      "surname": "Nom de famille"
    }
  }
}
